// ═══════════════════════════════════════════════════════════
// Public Requester Auth Store
// ═══════════════════════════════════════════════════════════

import { create } from 'zustand';
import {
  getPublicSession, clearPublicSession,
  loginPublicUser, registerPublicUser,
  type PublicUser,
} from '../api/publicAuth';

interface PublicAuthStore {
  user:    PublicUser | null;
  token:   string | null;
  loading: boolean;
  error:   string | null;
  login:    (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, firstName: string, lastName: string) => Promise<void>;
  logout:   () => void;
}

const session = getPublicSession();

export const usePublicAuthStore = create<PublicAuthStore>((set) => ({
  user:    session.user,
  token:   session.token,
  loading: false,
  error:   null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const { user, token } = await loginPublicUser({ email, password });
      set({ user, token, loading: false });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : 'Login failed', loading: false });
      throw e;
    }
  },

  register: async (email, password, firstName, lastName) => {
    set({ loading: true, error: null });
    try {
      const { user, token } = await registerPublicUser({ email, password, firstName, lastName });
      set({ user, token, loading: false });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : 'Registration failed', loading: false });
      throw e;
    }
  },

  logout: () => {
    clearPublicSession();
    set({ user: null, token: null });
  },
}));
